import { render, staticRenderFns } from "./SmallNotFound.vue?vue&type=template&id=4773b070&scoped=true"
var script = {}
import style0 from "./SmallNotFound.vue?vue&type=style&index=0&id=4773b070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4773b070",
  null
  
)

export default component.exports